import { Button, Modal } from "antd";

const DeactivateUser = ({
  isOpen,
  handleCancel,
  user,
  isDelete,
  selectedUsers,
  handleAction,
  isLoading
}) => {
  return (
    <Modal
      title={
        <div
          className="heading24px text-color-1C1C1C roboto-medium"
          style={{ padding: "20px 24px 10px" }}
        >
          {isDelete ? "Delete User" : "Deactivate User"}
        </div>
      }
      className="delete-popup"
      open={isOpen}
      centered
      footer={null}
      onOk={handleCancel}
      onCancel={handleCancel}
    >
      <div style={{ padding: "20px 24px 10px" }}>
        {isDelete
          ? !!selectedUsers?.length && !user
            ? "Are you sure you want to delete selected users? This action cannot be undone."
            : `Are you sure you want to delete ${user?.firstName} ${user?.lastName}? This action cannot be undone.`
          : !!selectedUsers?.length && !user
            ? "Are you sure you want to deactivate selected users? They will no longer be able to access the system."
            : !user?.active
              ? `Are you sure you want to activate ${user?.firstName} ${user?.lastName}? They will regain access to the system.`
              : `Are you sure you want to deactivate ${user?.firstName} ${user?.lastName}? They will no longer be able to access the system.`}
        <div
          className="mt20 d-flex justify-content-end align-items-center mb10"
          style={{ gap: 20 }}
        >
          <Button className="light-btn" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            disabled={isLoading}
            className={isDelete ? "stop-sync" : "warning-btn"}
            onClick={() => {
              handleCancel();
              handleAction();
            }}
          >
            {isDelete
              ? "Delete"
              : user?.active
                ? "Deactivate"
                : !!selectedUsers?.length && !user
                  ? "Deactivate"
                  : "Activate"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeactivateUser;
